module.exports = __webpack_public_path__ + "static/18-7532fb15d5ce54887017c018e1d6514d.jpg";